var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../../shared/configure-component-base';
import { CreateOrUpdateVariableGroupDto, VariableGroupListDto } from '../../../../../../shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
var VariableGroupModalComponent = /** @class */ (function (_super) {
    __extends(VariableGroupModalComponent, _super);
    function VariableGroupModalComponent(injector, variableGroupService, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.variableGroupService = variableGroupService;
        _this.bsModalRef = bsModalRef;
        _this.groupSavedEvent = new EventEmitter();
        _this.groupEditedEvent = new EventEmitter();
        _this.groupDeletedEvent = new EventEmitter();
        return _this;
    }
    VariableGroupModalComponent.prototype.ngAfterViewInit = function () {
        this.getConfigureVariableGroups();
    };
    VariableGroupModalComponent.prototype.getConfigureVariableGroups = function () {
        var _this = this;
        this.primengTableHelper.showLoadingIndicator();
        this.variableGroupService.getVariableGroups(this.configureId)
            .pipe(finalize(function () {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.hideLoadingIndicator();
        }))
            .subscribe(function (result) {
            _this.primengTableHelper.totalRecordsCount = result && result.length || 0;
            if (result) {
                _this.groupList = result;
            }
            else {
                _this.groupList = [];
            }
        });
    };
    VariableGroupModalComponent.prototype.close = function () {
        this.bsModalRef.hide();
    };
    VariableGroupModalComponent.prototype.addGroup = function () {
        var _this = this;
        var group = new VariableGroupListDto();
        this.groupList.unshift(group);
        setTimeout(function () {
            if (_this.button) {
                _this.button.nativeElement.click();
            }
        }, 100);
    };
    VariableGroupModalComponent.prototype.rowEditInit = function (record) {
        if (record.id) {
            this.groupNameCache = record.name;
        }
        this.groupEditing = true;
    };
    VariableGroupModalComponent.prototype.deleteGroup = function (record) {
        var _this = this;
        this.message.confirm(this.lc('DeletingVariableGroupWarningMessage', record.name), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.variableGroupService.deleteVariableGroup(_this.configureId, record.id)
                    .pipe(finalize(function () { return _this.groupEditing = false; }))
                    .subscribe(function (result) {
                    _this.groupDeletedEvent.emit(result);
                    _this.getConfigureVariableGroups();
                    _this.notify.success(_this.l('SuccessfullyDeleted'));
                });
            }
        });
    };
    VariableGroupModalComponent.prototype.saveGroup = function (record) {
        var _this = this;
        if (!record.name) {
            abp.notify.warn(this.lc('VariableGroupNameEmpty'));
            this.groupEditing = false;
            if (!record.id) {
                this.groupList.shift();
                return;
            }
            record.name = this.groupNameCache;
            return;
        }
        if (this.groupNameCache === record.name) {
            this.groupEditing = false;
            return;
        }
        var dto = new CreateOrUpdateVariableGroupDto();
        dto.configureId = this.configureId;
        if (record.id) {
            dto.id = record.id;
        }
        dto.name = record.name;
        this.saving = true;
        this.variableGroupService.createOrUpdateVariableGroup(dto)
            .pipe(finalize(function () {
            _this.getConfigureVariableGroups();
            _this.groupEditing = false;
            _this.saving = false;
        }))
            .subscribe(function () {
            abp.notify.info(_this.l('SavedSuccessfully'));
            if (record.id) {
                _this.groupEditedEvent.emit();
                return;
            }
            _this.groupSavedEvent.emit();
        });
    };
    VariableGroupModalComponent.prototype.restoreGroup = function (record) {
        this.groupEditing = false;
        if (!record.id) {
            this.groupList.shift();
            return;
        }
        record.name = this.groupNameCache;
    };
    VariableGroupModalComponent.prototype.trim = function (record) {
        record.name = record.name && record.name.trim();
    };
    __decorate([
        Input()
    ], VariableGroupModalComponent.prototype, "configureId", void 0);
    __decorate([
        Output()
    ], VariableGroupModalComponent.prototype, "groupSavedEvent", void 0);
    __decorate([
        Output()
    ], VariableGroupModalComponent.prototype, "groupEditedEvent", void 0);
    __decorate([
        Output()
    ], VariableGroupModalComponent.prototype, "groupDeletedEvent", void 0);
    __decorate([
        ViewChild('variableGroupDataTable', { static: true })
    ], VariableGroupModalComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('createGroupButton', { static: false })
    ], VariableGroupModalComponent.prototype, "button", void 0);
    VariableGroupModalComponent = __decorate([
        Component({
            selector: 'variable-group-modal',
            template: "<div class=\"modal-content fe-modal-container\" bs-modal-drag> <div class=\"modal-header fe-modal-header border-bottom\"> <h4 class=\"fe-modal-header-title\"> <span>{{lc('VariableGroupManage')}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"modal-body\"> <div class=\"group-action\"> <div class=\"variable-operation\"> <div class=\"operation-button\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"groupEditing\" (click)=\"addGroup()\">{{lc('AddGroup')}}</button> </div> </div> </div> <div class=\"primeng-datatable-container designer-actions-style\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #variableGroupDataTable [value]=\"groupList\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [scrollable]=\"true\" dataKey=\"id\" editMode=\"row\" [scrollHeight]=\"'300px'\" ScrollWidth=\"100%\" [responsive]=\"primengTableHelper.isResponsive\"> <ng-template pTemplate=\"header\"> <tr> <th class=\"col-md-2 col-xs-2\"> {{lc('GroupName')}} </th> <th class=\"col-md-2 col-xs-2 last-th\"> {{l('Actions')}} <span class=\"fa fa-cog fa-fw\"></span> </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record let-editing=\"editing\"> <tr [pEditableRow]=\"record\"> <td> <p-cellEditor> <ng-template pTemplate=\"input\"> <input class=\"input\" pInputText type=\"text\" [(ngModel)]=\"record.name\" maxlength=\"20\" (blur)=\"trim(record)\" required autoFocus> </ng-template> <ng-template pTemplate=\"output\"> {{record.name}} </ng-template> </p-cellEditor> </td> <td class=\"operation\"> <a *ngIf=\"!editing && !record.id\" [class.disabled]=\"groupEditing\" pInitEditableRow #createGroupButton (click)=\"rowEditInit(record)\">{{l('Edit')}}</a> <a *ngIf=\"!editing && record.id\" [class.disabled]=\"groupEditing\" pInitEditableRow (click)=\"rowEditInit(record)\">{{l('Edit')}}</a> <a *ngIf=\"!editing\" [class.disabled]=\"groupEditing\" (click)=\"deleteGroup(record)\">{{l('Delete')}}</a> <a *ngIf=\"editing\" pSaveEditableRow (click)=\"saveGroup(record)\">{{l('Save')}}</a> <a *ngIf=\"editing\" pCancelEditableRow (click)=\"restoreGroup(record)\">{{l('Cancel')}}</a> </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"!groupList || groupList.length == 0\"> {{l('NoData')}} </div> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l('Cancel')}} </button> </div> </div> </div> ",
            styles: [".variable-operation { .operation-button { button { margin-bottom: 12px; } button:not(:last-child) { margin-right: 12px; } } } .input { height: 30px; } .operation { text-align: right !important; a { color: #3695FF; cursor: pointer; } a:first-child { margin-right: 10px; } a.disabled { cursor: not-allowed; pointer-events: none; color: #C4C6CF; } } "]
        })
    ], VariableGroupModalComponent);
    return VariableGroupModalComponent;
}(ConfigureComponentBase));
export { VariableGroupModalComponent };
